/**
 * Generated runtime TestId mirror for frontend/src/components/demo/UnifiedSearchBarDemo.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const UnifiedSearchBarDemoTestIds = {
  demoBoolean: "demo-boolean",
  demoCardTitle: "demo-card-title",
  demoDaterange: "demo-daterange",
  demoDynamicAttr: "demo-dynamic-attr",
  demoEmpty: "demo-empty",
  demoManyChips: "demo-many-chips",
  demoMultiEnum: "demo-multi-enum",
  demoNullSentinel: "demo-null-sentinel",
  demoPageTitle: "demo-page-title",
  demoStatusMulti: "demo-status-multi",
  demoTextOnly: "demo-text-only",
  demoUuidPending: "demo-uuid-pending"
} as const;
